// Calendar dates and API boundaries use the viewer's local timezone consistently.
export function calendarPeriod(month: Date) {
  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const start = new Date(first.getFullYear(), first.getMonth(), 1 - first.getDay());
  const last = new Date(month.getFullYear(), month.getMonth() + 1, 0);
  const end = new Date(last.getFullYear(), last.getMonth(), last.getDate() + 7 - last.getDay());
  const days: Date[] = [];
  for (const day = new Date(start); day < end; day.setDate(day.getDate() + 1)) days.push(new Date(day));
  return { days, starts_from: start.toISOString(), starts_before: end.toISOString() };
}

export function calendarDateKey(date: Date) {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}
